import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { CustomerCharter } from '../../../portal/charters/charter-payment/charter-payment.component';
import { CharterDAO } from '../../../../core/services/dao/charterDAO';
import { Charter } from 'anchor-shared/lib/model/entity/charter';

@Component({
  selector: 'app-customer-charter-details-dialog',
  templateUrl: './customer-charter-details-dialog.component.html',
  styleUrls: ['./customer-charter-details-dialog.component.scss'],
})
export class CustomerCharterDetailsDialogComponent {
  charter: Charter;
  charterDetails: CustomerCharter;
  discount: number = 0;
  loading: boolean = true;

  constructor(
    private charterDAO: CharterDAO,
    public dialogRef: MatDialogRef<CustomerCharterDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.charter = data.charter;
    this.charterDAO
      .getCustomerCharterDetails(this.charter.id)
      .subscribe((charterDetails) => {
        this.charterDetails = charterDetails;
        this.loading = false;
      });
    this.discount = this.calculateDiscount();
  }

  createDateString(date, time, additionalTime?) {
    const dateTime = moment(date + ' ' + time);
    if (additionalTime) {
      dateTime.add(additionalTime, 'hour');
    }
    return dateTime.format('ddd, MMMM D, YYYY · h:mm A');
  }

  close() {
    this.dialogRef.close();
  }

  calculateDiscount() {
    return (
      Number(
        this.charter.discounts?.reduce((acc, curr) => acc + curr.amount, 0),
      ) || 0
    );
  }
}
